import { QueryCache, QueryClient } from '@tanstack/react-query'
import { reportLoadFailure } from './loadFailure'

// RELIABILITY-1: EVERY react-query failure is reported, not just the ten pages
// that render LoadErrorCard by hand.
//
// The audit found the manual useEffect pages were silent. react-query pages
// were silent too, for a different reason: a failed query rejects inside the
// library, the component renders `isError`, and nothing ever reaches Sentry.
// AgencyReporting is exactly that shape — it shows LoadErrorCard from
// `isError` with no catch block anywhere to attach a report to.
//
// A QueryCache-level onError fires once per failed query, after the built-in
// retries are exhausted, so it reports real failures rather than every
// transient blip. It is the single place that covers every current and future
// react-query call site without any of them remembering to.
const queryCache = new QueryCache({
  onError: (error, query) => {
    reportLoadFailure(error, {
      label: String(query.queryKey?.[0] ?? 'query'),
      extra: { query_key: JSON.stringify(query.queryKey).slice(0, 300), source: 'react-query' },
    })
  },
})

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
    mutations: { retry: 0 },
  },
})
